"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatClientCategory = exports.parseClientCategory = exports.getRevenueCategoryId = exports.formatRevenueCategory = exports.parseRevenueCategory = void 0;
exports.getClientCategoryId = getClientCategoryId;
var lodash_1 = require("lodash");
// --------------------------------
// Revenue Category
// --------------------------------
var revenueCategoryLabels = {
    SOFTWARE_HC: 'Logiciel - HC',
    SOFTWARE_ALD: 'Logiciel - ALD',
    SOFTWARE_AND_REGULATION_ALD: 'Logiciel + Régulation ALD',
    SOFTWARE_AND_REGULATION_HC: 'Logiciel + Régulation HC',
    SOFTWARE_AND_INVOICING_HC: 'Logiciel + Facturation HC',
    SOFTWARE_AND_REGULATION_AND_INVOICING_HC: 'Logiciel + Régulation + Facturation HC',
    FAS: 'FAS',
    OTHER_RECURRING_MF: 'Autre récurrent ES',
    RECURRING_MT: 'Récurrent TS',
    GEOLOCATION_MT: 'Géolocalisation TS',
    RECURRING_TELEPHONY_AND_IT: 'Récurrent téléphonie & informatique',
    OTHER_REVENUE: 'Autre CA',
};
var revenueCategorybyLabel = (0, lodash_1.invert)(revenueCategoryLabels);
var parseRevenueCategory = function (sfLabel) {
    var revenueCategoryEnum = revenueCategorybyLabel[sfLabel];
    if (!revenueCategoryEnum) {
        throw Error("Unexpected value for SF Categorie_revenus__c: ".concat(sfLabel));
    }
    return revenueCategoryEnum;
};
exports.parseRevenueCategory = parseRevenueCategory;
var formatRevenueCategory = function (r) {
    var label = revenueCategoryLabels[r];
    if (!label) {
        throw Error("Unexpected value for Revenue Category: ".concat(r));
    }
    return label;
};
exports.formatRevenueCategory = formatRevenueCategory;
var revenueCategoryMapping = {
    SOFTWARE_HC: 'd5eae586-074f-46dc-b8d9-a4173d7189ce',
    SOFTWARE_ALD: '3435cd56-bf57-4182-b74c-c21c55307393',
    SOFTWARE_AND_REGULATION_ALD: 'ec9c9fc1-c118-4273-b710-721effd09da3',
    SOFTWARE_AND_REGULATION_HC: '94b9e253-84b5-4eb3-a55b-0ee809f29336',
    SOFTWARE_AND_INVOICING_HC: 'e33d4e27-c9c7-4c34-8c6a-b4f59ed82c82',
    SOFTWARE_AND_REGULATION_AND_INVOICING_HC: 'a05225b2-b72a-4f70-ac29-02ccae100ef3',
    FAS: '4be1419b-5480-49c9-9eb4-a054337222cf',
    OTHER_RECURRING_MF: '43fc147c-ba45-4dba-8a92-362b92421686',
    RECURRING_MT: 'f20c2f8b-f747-405c-9121-61a1d5dd7ea7',
    GEOLOCATION_MT: '028579a2-b965-4108-acb9-8b713e0ce088',
    RECURRING_TELEPHONY_AND_IT: '49ebccff-51b4-4001-9e8a-4bea65ad3909',
    OTHER_REVENUE: '0f4f18d9-41b7-4285-8262-aeaa1e6ea688',
};
var getRevenueCategoryId = function (r) {
    return revenueCategoryMapping[r];
};
exports.getRevenueCategoryId = getRevenueCategoryId;
// --------------------------------
// Client Category
// --------------------------------
var clientCategoryLabels = {
    EMEIS: 'Emeis',
    CLARIANE: 'Clariane',
    ELSAN: 'Elsan',
    MF_NA: 'ES N-A',
    CH_GHT_CENTRALES_HORS_NA: 'CH / GHT / Centrales hors NA',
    OTHER_MF: 'Autres ES',
    OTHER_ALD: 'Autres ALD',
    GROUPEMENT_MT: 'Groupement TS',
    TDR: 'TDR',
    MT_NA: 'TS N-A',
    OTHER_MT: 'Autres TS',
    RECURRING_PHONE_AND_IT: 'Récurrent téléphonie & informatique',
};
var clientCategorybyLabel = (0, lodash_1.invert)(clientCategoryLabels);
var parseClientCategory = function (sfLabel) {
    var clientCategoryEnum = clientCategorybyLabel[sfLabel];
    if (!clientCategoryEnum) {
        throw Error("Unexpected value for SF Categorie_client__c: ".concat(sfLabel));
    }
    return clientCategoryEnum;
};
exports.parseClientCategory = parseClientCategory;
var formatClientCategory = function (c) {
    var label = clientCategoryLabels[c];
    if (!label) {
        throw Error("Unexpected value for Client Category: ".concat(c));
    }
    return label;
};
exports.formatClientCategory = formatClientCategory;
var clientCategoryMapping = [
    {
        conditions: {
            clientCategory: { include: ['OTHER_MT'] },
        },
        dev: { label: 'Bureaux', sourceId: '49f1622b-449f-4be7-a50d-8772197bbdb2' },
        prod: { label: 'Autre TS', sourceId: 'c2a473ba-a997-4345-b31d-5a4564eec8e9' },
    },
    {
        conditions: {
            clientCategory: { include: ['GROUPEMENT_MT'] },
        },
        dev: { label: 'Groupement TS', sourceId: 'e1f2b75b-51ce-4979-ad28-dbcf50e224be' },
        prod: { label: 'Groupement TS', sourceId: 'a15cc416-5bea-4f0c-ab1c-dd34006828c1' },
    },
    {
        conditions: {
            clientCategory: { include: ['MT_NA'] },
        },
        dev: { label: 'Déplacements', sourceId: 'cb88199b-8d60-47ab-8616-e176a1465901' },
        prod: { label: 'TS N-A', sourceId: 'f6782249-25fd-42d6-ba19-15b6b29b1810' },
    },
    {
        conditions: {
            clientCategory: { include: ['OTHER_MF'] },
        },
        dev: { label: 'Autres récurrents ES', sourceId: '9babafe5-d589-41ac-91f9-25caaa261d65' },
        prod: { label: 'Autres ES', sourceId: '83cf3c69-f153-4f92-942d-eb9c732291eb' },
    },
    {
        conditions: {
            clientCategory: { include: ['OTHER_ALD'] },
        },
        dev: { label: 'Loyers', sourceId: '83fb6ea2-11b3-4640-b24b-ca386f314ebe' },
        prod: { label: 'Autres ALD', sourceId: 'b810a478-6539-4dce-8e34-df306865dd7d' },
    },
    {
        conditions: {
            clientCategory: { include: ['TDR'] },
        },
        dev: { label: 'TDR', sourceId: '1232eef3-44a0-4568-9347-edc3c36c1334' },
        prod: { label: 'TDR', sourceId: '14117740-d9ee-465a-b241-10bdf1d5dd9d' },
    },
    {
        conditions: {
            clientCategory: { include: ['RECURRING_PHONE_AND_IT'] },
        },
        dev: { label: 'Téléphone & Internet', sourceId: 'fd1171ec-93d3-46d2-ac45-b4d24153de57' },
        prod: { label: 'Récurrent téléphonie & informatique', sourceId: '3c929385-3d5f-487d-be75-1e56840c596c' },
    },
    // Mappings for non-Emeis/Clariane ALD
    {
        conditions: {
            clientCategory: { exclude: ['EMEIS', 'CLARIANE'] },
            revenueCategory: {
                anyOf: ['SOFTWARE_ALD', 'SOFTWARE_AND_REGULATION_ALD'],
            },
        },
        dev: { label: 'Loyers', sourceId: '83fb6ea2-11b3-4640-b24b-ca386f314ebe' },
        prod: { label: 'Autres ALD', sourceId: 'b810a478-6539-4dce-8e34-df306865dd7d' },
    },
    // CH/GHT/Centrales mapping
    {
        conditions: {
            clientCategory: { include: ['CH_GHT_CENTRALES_HORS_NA'] },
            revenueCategory: {
                anyOf: [
                    'SOFTWARE_HC',
                    'SOFTWARE_AND_REGULATION_AND_INVOICING_HC',
                    'SOFTWARE_AND_INVOICING_HC',
                    'SOFTWARE_AND_REGULATION_HC',
                ],
            },
        },
        dev: { label: 'Restauration', sourceId: '97108872-a343-4e18-9243-ab419cf59980' },
        prod: { label: 'CH / GHT / Centrales', sourceId: '68f501ed-9d4f-4270-a09f-3ea31bcff441' },
    },
    // Clariane mappings
    {
        conditions: {
            clientCategory: { include: ['CLARIANE'] },
            revenueCategory: {
                anyOf: ['SOFTWARE_ALD', 'SOFTWARE_AND_REGULATION_ALD'],
            },
        },
        dev: { label: 'Clariane ALD', sourceId: '54f1cdb4-76ac-4d13-80a8-36f482b9be75' },
        prod: { label: 'Clariane ALD', sourceId: '14b09afc-c9e6-463a-b923-e26a7b45ede1' },
    },
    {
        conditions: {
            clientCategory: { include: ['CLARIANE'] },
            revenueCategory: {
                anyOf: [
                    'SOFTWARE_HC',
                    'SOFTWARE_AND_REGULATION_AND_INVOICING_HC',
                    'SOFTWARE_AND_INVOICING_HC',
                    'SOFTWARE_AND_REGULATION_HC',
                ],
            },
        },
        dev: { label: 'Clariane HC', sourceId: 'ef0a9202-c82c-49c9-8221-2db361fd20d4' },
        prod: { label: 'Clariane HC', sourceId: '91b3527f-0a70-4666-a15d-1254b54c6ab7' },
    },
    // Elsan mapping
    {
        conditions: {
            clientCategory: { include: ['ELSAN'] },
            revenueCategory: {
                anyOf: [
                    'SOFTWARE_HC',
                    'SOFTWARE_AND_REGULATION_AND_INVOICING_HC',
                    'SOFTWARE_AND_INVOICING_HC',
                    'SOFTWARE_AND_REGULATION_HC',
                ],
            },
        },
        dev: { label: 'Elsan', sourceId: 'a19677bc-afce-460f-a083-69cbd4d50f87' },
        prod: { label: 'Elsan', sourceId: '7d54956e-36ef-4409-b0ec-84227a97fcd9' },
    },
    // Emeis mappings
    {
        conditions: {
            clientCategory: { include: ['EMEIS'] },
            revenueCategory: {
                anyOf: ['SOFTWARE_ALD', 'SOFTWARE_AND_REGULATION_ALD'],
            },
        },
        dev: { label: 'Emeis ALD', sourceId: '4374ecc3-0eaa-4094-99d4-bce2ff7ac3a2' },
        prod: { label: 'Emeis ALD', sourceId: '4ac40d36-3cb0-4187-b270-3d2cb6967c3c' },
    },
    {
        conditions: {
            clientCategory: { include: ['EMEIS'] },
            revenueCategory: {
                anyOf: [
                    'SOFTWARE_HC',
                    'SOFTWARE_AND_REGULATION_AND_INVOICING_HC',
                    'SOFTWARE_AND_INVOICING_HC',
                    'SOFTWARE_AND_REGULATION_HC',
                ],
            },
        },
        dev: { label: 'Emeis HC', sourceId: '6c3a02e2-0122-4018-bf1e-bac155eec248' },
        prod: { label: 'Emeis HC', sourceId: '32703950-3525-4f8b-88df-2ab62885319f' },
    },
    // N-A mapping
    {
        conditions: {
            clientCategory: { include: ['MF_NA'] },
            revenueCategory: {
                anyOf: [
                    'SOFTWARE_HC',
                    'SOFTWARE_AND_REGULATION_AND_INVOICING_HC',
                    'SOFTWARE_AND_INVOICING_HC',
                    'SOFTWARE_AND_REGULATION_HC',
                ],
            },
        },
        dev: { label: 'Juridique', sourceId: '51d9b15a-d6f3-432a-89b4-c5c546b148c5' },
        prod: { label: 'ES N-A', sourceId: '97dea250-7156-4614-9bab-b2c94ee8762d' },
    },
];
function getClientCategoryId(clientCategory, revenueCategory) {
    var _a;
    var env = process.env.AMBLER_STAGE !== 'prod' ? 'dev' : 'prod';
    if (!clientCategory || !revenueCategory) {
        return undefined;
    }
    // Special case for FAS revenue category
    if (revenueCategory === 'FAS') {
        var fasMapping = {
            prod: {
                label: 'FAS (catégorie Reporting)',
                sourceId: 'b23490d0-ac7f-41f4-9e45-82908849b956',
            },
            dev: {
                label: 'Alimentaire',
                sourceId: '19c7d4a9-2111-4c37-8e6f-fba9cc34b45a',
            },
        };
        return fasMapping[env].sourceId;
    }
    var foundMapping = clientCategoryMapping.find(function (mapping) {
        // Check client category conditions
        if (mapping.conditions.clientCategory) {
            var _a = mapping.conditions.clientCategory, include = _a.include, exclude = _a.exclude;
            if (include && !include.includes(clientCategory)) {
                return false;
            }
            if (exclude === null || exclude === void 0 ? void 0 : exclude.includes(clientCategory)) {
                return false;
            }
        }
        // Check revenue category conditions
        if (mapping.conditions.revenueCategory && revenueCategory) {
            var anyOf = mapping.conditions.revenueCategory.anyOf;
            if (anyOf && !anyOf.includes(revenueCategory)) {
                return false;
            }
        }
        return true;
    });
    return (_a = foundMapping === null || foundMapping === void 0 ? void 0 : foundMapping[env]) === null || _a === void 0 ? void 0 : _a.sourceId;
}
//# sourceMappingURL=salesforce.js.map